import React, { useCallback, useRef } from 'react';
import { GlobalStyle } from '../../styles/global';
import logoImg from '../../assets/metodo-billings-marca-dashboard.png';
import logogoogle from '../../assets/logogoogle.png';
import { GoogleLogin } from 'react-google-login';
import { Link, useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import Input from '../../components/Elements/Input';
import Button from '../../components/Elements/Button';
import { Container } from './styles';
import getValidationErros from '../../utils/getValidationErros';
import { useAuth } from '../../hooks/Auth';
import toast from 'react-hot-toast';
import {api} from '../../services/api';

interface SignInFormData{
    email: string;
    pass: string;
}

const SignIn: React.FC = () => {

    const formRef = useRef<FormHandles>(null);
    const { signIn } = useAuth();
    const history = useHistory();

    const onSuccess = async (response : any) => {
        //console.log('in');
        //console.log(response);
       
        const userID = response.profileObj.googleId;            
        const userName = response.profileObj.name;
        const userEmail = response.profileObj.email;
        const userPicture = response.profileObj.imageUrl ? response.profileObj.imageUrl : null;
        const LoR = response.tokenId;
        const datag = { userID: userID, userName: userName, userEmail: userEmail, userPicture: userPicture, token: LoR };
        //console.log(datag);
        try {
            const resp = await api.post('login_google.php', datag);

            localStorage.setItem('@mob:jwt', resp.data.jwt );
            localStorage.setItem('@mob:user', JSON.stringify(resp.data.user));

            window.location.reload();

        } catch (err: any) {
            let error = err.toString();
            if(error.search("Network Error")){
                toast.loading('ESTAMOS COM PROBLEMAS NO BANCO DE DADOS, POR FAVOR TENTE MAIS TARDE.');
            } else {
                toast.error('DESCULPE NÃO CONSEGUIMOS ACESSO');
            }
        }
        
    }

    const onFailure = (response : any) => {
        //console.log('fail');
        //console.log(response);
        if(response.error !== 'idpiframe_initialization_failed'){
            toast.error('NÃO AUTORIZADO.');
        }
    }


    const handleLogin = useCallback(async (data: SignInFormData) => {
        
        try {

            formRef.current?.setErrors({});
            const schema = Yup.object().shape({
                email: Yup.string().required('Email obrigatório').email('Insira um email válido'),
                pass: Yup.string().required('Senha Obrigatória'),
            });
            await schema.validate(data, { abortEarly: false, });

            await signIn({ 
                email: data.email, 
                pass: data.pass,
            });            
            history.push('/dashboard');

        } catch (err) {            
            if(err instanceof Yup.ValidationError){
                const errors = getValidationErros(err);
                formRef.current?.setErrors(errors);
                return;
            }
            // toast.error('ERRO, VERIFIQUE SEUS DADOS');
        }
    }, [history, signIn]);

   
    return ( 
    <>
        <Container>
            <img src={logoImg} alt="Método Billings" />
            <Form ref={formRef} onSubmit={handleLogin}>
                <Input type="text" defaultValue="" name="email" placeholder="SEU EMAIL" />
                <Input type="password" defaultValue="" name='pass' placeholder="SUA SENHA" />
                <Button type="submit">entrar</Button>                
                
                <GoogleLogin
                    clientId="696958825806-hnsv5i0et1qh5ga12g26hstkp49kvc4d.apps.googleusercontent.com"                    
                    render={renderProps => (
                        <button className="google" onClick={renderProps.onClick} >
                            <img src={logogoogle} alt="" />
                            USAR O GOOGLE
                        </button>
                        )}
                    buttonText="USAR O GOOGLE"                    
                    onSuccess={onSuccess}
                    onFailure={onFailure}
                    cookiePolicy={'single_host_origin'}                    
                />
                <div className="outros">
                    <Link to="/cadastro" className="botao">Fazer cadastro</Link>
                    <Link to="/esqueciasenha" className="botao">Esqueci a senha</Link>
                </div>
            </Form>
        </Container>
        <GlobalStyle />
    </>
    );
}

export default SignIn;